import { DeclaredTerritoryMapping } from "../domain/constants/declared-territory.mapping";
import { WorkGroupsMapping } from "../domain/constants/work-groups.mapping";
import { FilterPayload } from "../domain/interfaces/Filter.interface";

export const AlertsVisualizationMvtBuilder = (filter: FilterPayload) => {
  let urlParamsFilter = [];

  if (filter.name) {
    urlParamsFilter.push(`name ILIKE '%${filter.name}%' OR povos_kit_number ILIKE '%${filter.name}%'`);
  }

  if (filter.states && filter.states.length) {
    const statesParams = filter.states.map((value: any) => `'${value}' = geo_state_id`);
    urlParamsFilter.push(`(${statesParams.join(' OR ')})`);
  }

  if (filter.municipalities && filter.municipalities.length) {
    const municipalitiesParams = filter.municipalities.map((value: any) => `'${value}' = geo_municipalities_id`);
    urlParamsFilter.push(`(${municipalitiesParams.join(' OR ')})`);
  }

  if (filter.indigenousLands && filter.indigenousLands.length) {
    const indigenousLandsParams = filter.indigenousLands.map((value: any) => `'${value}' = any(indigenous_land_id)`);
    urlParamsFilter.push(`(${indigenousLandsParams.join(' OR ')})`);
  }

  if (filter.conservationUnits && filter.conservationUnits.length) {
    const conservationUnitsParams = filter.conservationUnits.map((value: any) => `'${value}' = any(conservation_unit_id)`);
    urlParamsFilter.push(`(${conservationUnitsParams.join(' OR ')})`);
  }

  if (filter.specialTerritories && filter.specialTerritories.length) {
    let specialTerritoriesParams = filter.specialTerritories.map(
      (value: { id: number; name: string; category: string }) => {
        if (value.category == 'Quilombo') {
          return `'${value.id}' = any(quilombo_id)`;
        } else if (value.category == 'PAE') {
          return `'${value.id}' = any(settlement_id)`;
        } else {
          return `'${value.id}' = any(territory_id)`;
        }
      }
    );
    urlParamsFilter.push(`(${specialTerritoriesParams.join(' OR ')})`);
  }

  if (filter.status && filter.status.length) {
    if(filter.status.map((value: any) => value).includes('9')) {
      urlParamsFilter.push(`maintenance_is_finished IS FALSE`);
    } else {
      const statusParams = filter.status.map((value: any) => `'${value}' = communities_kit_status_id`);
      urlParamsFilter.push(`(${statusParams.join(' OR ')})`);
    }
  }

  if (filter.awaitingMaintenanceStatus) {
    if (filter.awaitingMaintenanceStatus == 'Sim') {
      urlParamsFilter.push(`maintenance_is_finished IS FALSE`);
    } else {
      urlParamsFilter.push(`maintenance_is_finished IS TRUE`);
    }
  }

  if (filter.connectionTypes && filter.connectionTypes.length) {
    const connectionTypeParams = filter.connectionTypes.map((value: any) => `'${value}' = service_pl`);
    urlParamsFilter.push(`(${connectionTypeParams.join(' OR ')})`);
  }

  if (filter.contractType && filter.contractType.length) {
    if (filter.contractType == 'Antenas Externas Incorporadas') {
      urlParamsFilter.push(`service_pl = 'Antenas Externas Incorporadas'`);
    } else {
      urlParamsFilter.push(`service_pl != 'Antenas Externas Incorporadas'`);
    }
  }

  if (filter.partners && filter.partners.length) {
    const partnersParams = filter.partners.map((value: any) => `'${value}' = partners_id`);
    urlParamsFilter.push(`(${partnersParams.join(' OR ')})`);
  }

  if (filter.energyKitModel && filter.energyKitModel.length) {
    const energyKitModelParams = filter.energyKitModel.map((value: any) => `energy_kit_name ${value === 'Sem Kit' ? 'IS NULL' : "= '"+value+"'"}`);
    urlParamsFilter.push(`(${energyKitModelParams.join(' OR ')})`);
  }

  if (filter.dateStart && filter.dateEnd) {
    urlParamsFilter.push(
      `(created_at BETWEEN \'${filter.dateStart}\' AND \'${filter.dateEnd}\')`
    )
  }

  if (filter.declaredTerritory && filter.declaredTerritory.length) {
    const declaredTerritoryParams = filter.declaredTerritory.map((value: any) => `${DeclaredTerritoryMapping[value]} is TRUE`);
    urlParamsFilter.push(`${declaredTerritoryParams.join(' OR ')}`);
  }

  if (filter.workGroups && filter.workGroups.length) {
    const workGroupsParams = filter.workGroups.map((value: any) => `${WorkGroupsMapping[value]} is TRUE`);
    urlParamsFilter.push(`${workGroupsParams.join(' OR ')}`);
  }

  if (filter.association) {
    if (filter.association == 'Sim') {
      urlParamsFilter.push(`has_association IS TRUE`);
    } else {
      urlParamsFilter.push(`has_association IS FALSE`);
    }
  }

  if (filter.routerModel && filter.routerModel.length) {
    const routerModelParams = filter.routerModel.map((value: any) => `router_version = '${value}'`);
    urlParamsFilter.push(`(${routerModelParams.join(' OR ')})`);
  }

  const urlParamsFilterStr = urlParamsFilter.join(' AND ');

  return urlParamsFilterStr;
}
